
import TaskSquare from "../../../assets/duotone/TaskSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TaskSquareIcon({ className, dataTestid = "TaskSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TaskSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
